import TopGlow from "./topGlow"
// import WavesBg from "./WavesBg"

const Layout = ({ children }) => (
  <div
    css={{
      fontWeight: 400,
      color: "white",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      maxWidth: 480,
      width: "100%",
      height: "100%",
      minHeight: 0,
      overflow: "hidden",
      alignItems: "center",
      margin: "0 auto",
      boxSizing: "border-box",
    }}
  >
    <TopGlow />

    <div
      css={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: 24,
        flex: 1,
        minHeight: 0,
        width: "100%",
        padding: "16px 24px 24px 24px",
      }}
    >
      {children}
    </div>
  </div>
)

export default Layout
